import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  }
}));

export default function ErrorTemplate (props) {
  const { errors } = props;
  const classes = useStyles();

  return errors.map((error, i) => (
    <div className={classes.root}>
      <Alert key={error.stack + '-' + i} severity='error' onClose={() => {}}>
        {error.message}
      </Alert>
    </div>
  ));
}
